const APIS = {
  MANIFEST: "/manifestservice/api/manifest/",
  ORDER: "/manifestservice/api/order/available-consignments/",
  BRANCH: "/logisticservice/api/branch/",
  REMARK: "logisticservice/api/remark/",
  DRIVER: "/fleetservice/api/driver/",
  LOCATION: "/logisticservice/api/location/",
  DRIVER_CREATE: "/fleetservice/api/driver/create-rider/",
  MANIFEST_REPORT: "/manifestservice/api/manifest/manifest-report",
  VEHICLE: "fleetservice/api/vehicle/",
  COMMENT: "/commentservice/api/comment/",
  CUSTOMER: "/logisticservice/api/customer/",
  FLAT_LOCATION: "/logisticservice/api/location/flat-location/",
  MERCHANT: "/logisticservice/api/merchant/",
  PRODUCT_TYPE: "/logisticservice/api/product-type/",
  REFERENCE_TYPE: "/logisticservice/api/reference-type/",
  MANIFEST_ITEMS: "/manifestservice/api/manifest-item/",
  EXPENSE_NOTE: "/manifestservice/api/expense-note/",
  STATUS: "/logisticservice/api/status/",
  SHIP_VIA: "/logisticservice/api/ship-via/",
  MANIFEST_STATUS: "/manifestservice/api/manifest-settings/",
  DELIVERY_SETTING: "/logisticservice/api/delivery-settings/",
  USER: "/usermanagementservice/api/user/",
  STATUS_NEXT: "logisticservice/api/status/next-status/",
  DELIVERY: "/manifestservice/api/delivery/",
  DELIVERY_ITEMS: "/manifestservice/api/delivery-item/",
  LOGISTIC_ORDER: "/logisticservice/api/order/",
};

export default APIS;
